import Layout from "../../layout/Layout";
import { useAuth } from "../../../components/context/AuthContext";

import { Bar, Pie } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend
);

// ======================================================================
// RANDOM VERİLER
// ======================================================================
const OPERATORS = ["F TONGA", "A GÜL", "S ÇELİK", "M DEMİR"];
const FIELDS = ["firma", "boy", "kalinlik", "kaynakNote", "bagAdeti"];
const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

// 40 form üretim
const generateForms = () => {
  const a = [];
  for (let i = 0; i < 40; i++) {
    const op = OPERATORS[rand(0, OPERATORS.length - 1)];
    a.push({
      operator: op,
      mamulKg: rand(10000, 45000),
      durus: rand(20, 180),
    });
  }
  return a;
};

// 80 log üretim
const generateLogs = () => {
  const a = [];
  for (let i = 0; i < 80; i++) {
    a.push({
      operator: OPERATORS[rand(0, OPERATORS.length - 1)],
      field: FIELDS[rand(0, FIELDS.length - 1)],
    });
  }
  return a;
};

const forms = generateForms();
const logs = generateLogs();

// ======================================================================
// OPERATÖR BAZLI LOG ANALİZ FONKSİYONU
// ======================================================================
function analyzeLogsForOperator(operatorName) {
  const opLogs = logs.filter((l) => l.operator === operatorName);

  if (opLogs.length === 0)
    return {
      total: 0,
      maxField: "-",
      maxCount: 0,
      percent: 0,
      fieldCounts: {},
    };

  const fieldCount = {};
  opLogs.forEach((l) => {
    if (!fieldCount[l.field]) fieldCount[l.field] = 0;
    fieldCount[l.field]++;
  });

  const sorted = Object.entries(fieldCount).sort((a, b) => b[1] - a[1]);
  const maxField = sorted[0][0];
  const maxCount = sorted[0][1];
  const percent = ((maxCount / opLogs.length) * 100).toFixed(1);

  return {
    total: opLogs.length,
    maxField,
    maxCount,
    percent,
    fieldCounts: fieldCount,
  };
}

// ======================================================================
// GLOBAL ANALİZ YARDIMCI FONKSİYONLAR
// ======================================================================

// Alan bazında toplam log sayısı
function getGlobalFieldStats(logs) {
  const map = {};
  logs.forEach((l) => {
    if (!map[l.field]) map[l.field] = 0;
    map[l.field]++;
  });
  return map;
}

// Operatör -> Alan bazlı dağılım
function getOperatorFieldStats(logs) {
  const map = {};
  logs.forEach((l) => {
    if (!map[l.operator]) map[l.operator] = {};
    if (!map[l.operator][l.field]) map[l.operator][l.field] = 0;
    map[l.operator][l.field]++;
  });
  return map;
}

// ======================================================================
// ANA COMPONENT
// ======================================================================
export default function OperatorPerformansPage() {
  const { user } = useAuth();
  if (!user) return <Layout />;

  // ------------------------------
  // FORM ANALİZİ
  // ------------------------------
  const grouped = {};
  forms.forEach((f) => {
    if (!grouped[f.operator])
      grouped[f.operator] = { ton: 0, durus: 0, adet: 0 };

    grouped[f.operator].ton += f.mamulKg;
    grouped[f.operator].durus += f.durus;
    grouped[f.operator].adet++;
  });

  const operatorNames = Object.keys(grouped);

  // GENEL METRİKLER
  const totalForms = forms.length;
  const totalLogs = logs.length;
  const avgLogsPerForm =
    totalForms > 0 ? (totalLogs / totalForms).toFixed(2) : "0.00";

  const globalFieldStats = getGlobalFieldStats(logs);
  const operatorFieldStats = getOperatorFieldStats(logs);

  // En çok hata yapan operatör (log sayısına göre)
  let topOperator = "-";
  let topOperatorLogs = 0;

  const operatorLogCounts = operatorNames.map((op) => {
    const stats = analyzeLogsForOperator(op);
    const total = stats.total;
    if (total > topOperatorLogs) {
      topOperatorLogs = total;
      topOperator = op;
    }
    return total;
  });

  // En çok hata yapılan alan
  const fieldEntries = Object.entries(globalFieldStats).sort(
    (a, b) => b[1] - a[1]
  );
  const [topFieldName, topFieldCount] = fieldEntries[0] || ["-", 0];
  const topFieldPercent =
    totalLogs > 0 ? ((topFieldCount / totalLogs) * 100).toFixed(1) : "0.0";

  // Alan bazlı: hangi operatör o alanda en çok hata yapmış
  const fieldTopOperatorMap = {};
  Object.entries(operatorFieldStats).forEach(([op, fieldsObj]) => {
    Object.entries(fieldsObj).forEach(([field, count]) => {
      if (!fieldTopOperatorMap[field]) {
        fieldTopOperatorMap[field] = { operator: op, count };
      } else {
        if (count > fieldTopOperatorMap[field].count) {
          fieldTopOperatorMap[field] = { operator: op, count };
        }
      }
    });
  });

  // ======================================================================
  // GRAFİK 1 — Üretim Bar Chart
  // ======================================================================
  const productionBar = {
    labels: operatorNames,
    datasets: [
      {
        label: "Üretim (ton)",
        data: operatorNames.map((o) =>
          Number((grouped[o].ton / 1000).toFixed(1))
        ),
        backgroundColor: "#4b79a1",
      },
    ],
  };

  // ======================================================================
  // GRAFİK 2 — Operatör Log Sayısı Bar Chart
  // ======================================================================
  const operatorLogBar = {
    labels: operatorNames,
    datasets: [
      {
        label: "Log Sayısı",
        data: operatorLogCounts,
        backgroundColor: "#c0392b",
      },
    ],
  };

  // ======================================================================
  // GRAFİK 3 — Genel Hata Alanları Pie Chart
  // ======================================================================
  const pieChart = {
    labels: Object.keys(globalFieldStats),
    datasets: [
      {
        data: Object.values(globalFieldStats),
        backgroundColor: ["#ff6384", "#36a2eb", "#ffce56", "#8e44ad", "#27ae60"],
      },
    ],
  };

  return (
    <Layout>
      <div className="container mt-4">
        <h2 className="fw-bold mb-4">Operatör Performans & Log Dashboard</h2>

        {/* =============================================================
            GENEL ÖZET KARTLARI
        ============================================================= */}
        <div className="row mb-4">
          <div className="col-6 col-md-3 mb-3">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="text-muted small">Toplam Form</div>
                <div className="fs-4 fw-bold">{totalForms}</div>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-3 mb-3">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="text-muted small">Toplam Log</div>
                <div className="fs-4 fw-bold">{totalLogs}</div>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-3 mb-3">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="text-muted small">Ortalama Log / Form</div>
                <div className="fs-4 fw-bold">{avgLogsPerForm}</div>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-3 mb-3">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="text-muted small">En Çok Hata Yapan Operatör</div>
                <div className="fw-bold">
                  {topOperator}{" "}
                  {topOperator !== "-" && (
                    <span className="text-muted">({topOperatorLogs} log)</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* İkinci satır kart: En çok hata yapılan alan */}
        <div className="row mb-4">
          <div className="col-12 col-md-4 mb-3">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="text-muted small">En Çok Hata Yapılan Alan</div>
                <div className="fw-bold">{topFieldName}</div>
                {topFieldName !== "-" && (
                  <div className="text-muted small">
                    {topFieldCount} log — %{topFieldPercent}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* =============================================================
            OPERATÖR PERFORMANS TABLOSU
        ============================================================= */}
        <h4 className="fw-bold mb-2">Operatör Bazlı Özet</h4>
        <table className="table table-bordered table-sm">
          <thead>
            <tr className="table-light">
              <th>Operatör</th>
              <th>Üretim (ton)</th>
              <th>Duruş (dk)</th>
              <th>Form Adedi</th>
              <th>Toplam Log</th>
              <th>En Çok Hata Alanı</th>
              <th>Alan Hata Sayısı</th>
              <th>Log İçinde %</th>
              <th>Hatalı Satır (%)</th>
            </tr>
          </thead>
          <tbody>
            {operatorNames.map((op) => {
              const stats = analyzeLogsForOperator(op);
              const adet = grouped[op].adet || 0;
              const hataliOran =
                adet > 0 ? ((stats.total / adet) * 100).toFixed(1) : "0.0";

              return (
                <tr key={op}>
                  <td>{op}</td>
                  <td>{(grouped[op].ton / 1000).toFixed(1)}</td>
                  <td>{grouped[op].durus}</td>
                  <td>{adet}</td>
                  <td>{stats.total}</td>
                  <td>{stats.maxField}</td>
                  <td>{stats.maxCount}</td>
                  <td>%{stats.percent}</td>
                  <td>%{hataliOran}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* =============================================================
            ALAN BAZLI HATA TABLOSU
        ============================================================= */}
        <h4 className="fw-bold mt-4 mb-2">Alan Bazlı Hata Analizi</h4>
        <table className="table table-bordered table-sm">
          <thead>
            <tr className="table-light">
              <th>Alan</th>
              <th>Toplam Hata</th>
              <th>Tüm Hatalar İçindeki %</th>
              <th>En Çok Hata Yapan Operatör</th>
              <th>Operatör Hata Sayısı</th>
            </tr>
          </thead>
          <tbody>
            {fieldEntries.map(([field, count]) => {
              const percent =
                totalLogs > 0 ? ((count / totalLogs) * 100).toFixed(1) : "0.0";
              const topInfo = fieldTopOperatorMap[field] || {
                operator: "-",
                count: 0,
              };

              return (
                <tr key={field}>
                  <td>{field}</td>
                  <td>{count}</td>
                  <td>%{percent}</td>
                  <td>{topInfo.operator}</td>
                  <td>{topInfo.count}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* =============================================================
            GRAFİK 1 — ÜRETİM BAR CHART
        ============================================================= */}
        <h4 className="fw-bold mt-4">Üretim (ton) — Bar Chart</h4>
        <div style={{ maxWidth: 700 }}>
          <Bar data={productionBar} />
        </div>

        {/* =============================================================
            GRAFİK 2 — OPERATÖR LOG SAYISI
        ============================================================= */}
        <h4 className="fw-bold mt-5">Operatörlere Göre Log Sayısı</h4>
        <div style={{ maxWidth: 700 }}>
          <Bar data={operatorLogBar} />
        </div>

        {/* =============================================================
            GRAFİK 3 — GENEL HATA ALANLARI PIE
        ============================================================= */}
        <h4 className="fw-bold mt-5">Hata Alanları Dağılımı (Pie)</h4>
        <div style={{ maxWidth: 380 }}>
          <Pie data={pieChart} />
        </div>
      </div>
    </Layout>
  );
}
